import { Injectable, inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { environment } from "../../../environments/environment";
import { Title, Meta } from "@angular/platform-browser";

@Injectable({
  providedIn: "root",
})
export class Seo {
  private doc = inject(DOCUMENT);
  private title = inject(Title);
  private meta = inject(Meta);

  canonicalLink: HTMLLinkElement;

  constructor() {
    this.setMeta({ property: "og:site_name", content: environment.title });
  }

  setCanonicalURL(url) {
    const links: HTMLLinkElement[] = Array.from(
      this.doc.head.getElementsByTagName("link"),
    );
    if (Symbol.iterator in Object(links)) {
      [...links].forEach((link) => {
        if (link.getAttribute("rel") === "canonical") {
          this.canonicalLink = link;
        }
      });
    }
    if (!this.canonicalLink) {
      this.canonicalLink = this.doc.createElement("link");
    }
    this.canonicalLink.setAttribute("rel", "canonical");
    this.canonicalLink.setAttribute("href", environment.fullUrl + url);
    this.doc.head.appendChild(this.canonicalLink);
    this.setMeta({ property: "og:url", content: environment.fullUrl + url });
  }

  setTitle(title) {
    this.title.setTitle(title);
    this.setMeta({ property: "og:title", content: title });
  }

  addImage(url) {
    this.setImage(url);
  }

  setImage(url) {
    this.setMeta({ property: "og:image", content: url });
  }

  unsetImage() {
    this.unsetMeta({ property: "og:image" });
  }

  setDescription(description) {
    this.setMeta({ name: "description", content: description });
    this.setMeta({ property: "og:description", content: description });
  }

  unsetDescription() {
    this.unsetMeta({ name: "description" });
    this.unsetMeta({ property: "og:description" });
  }

  addMeta(meta) {
    this.meta.addTag(meta);
  }

  setMeta(meta) {
    this.meta.updateTag(meta);
    // this.unsetMeta(meta);
    // this.addMeta(meta);
  }

  unsetMeta(meta) {
    if (meta.name) {
      this.meta.removeTag("name='" + meta.name + "'");
    }
    if (meta.property) {
      this.meta.removeTag("property='" + meta.property + "'");
    }
  }

  private createDomElements(descriptions, tag) {
    // console.log(tag, descriptions);
    for (const description of descriptions) {
      // console.log('description', description);
      const element = this.doc.createElement(tag);
      for (const key of Object.keys(description)) {
        element.setAttribute(key, description[key]);
      }
      if (!this.doc.head.contains(element)) {
        this.doc.head.appendChild(element);
      }
    }
  }
}
